import React, { useState, useEffect } from 'react';

import { Col, Dropdown, Modal } from 'react-bootstrap';
import './AllocateLoadUI.scss';
import { blockInvalidChar } from '../../../_common/blockInvalidChar';
import {
    GetStageSheet_getStageSheet_details as StageSheet,
    GetStageInfo_getStageInfo as Stages,
    GetPartials_getPartials as Partials,
    GetAllocateLoadBoxes_getAllocateLoadBoxes as AllocationLoadBoxes,
    GetBellyLoadAllocaions_getBellyLoadAllocaions as Allocations,
} from '../../../../types/schemaTypes';
import { CustomButton } from '../../../_common';


interface AllocateBoxProps {
    id: number;
    index: number;
    jobId: number;
    loadId: number;
    boxId: number;
    proppantId: number;
    boxDesc: string;
    allocationWeight: number;
    isBoxAllocated: boolean;
    isLoadAllocated: boolean;
    isSemiAllocated: boolean;
    isDeleted: boolean;
    currentWeight: number;
    isInDanceFloor: boolean;
}

interface StageSheetPartialModalRowProps {
    index: number;
    jobId: number;
    loadId: number;
    proppantId: number;
    stageSheetId: number;
    boxCount: number;
    allocation?: Allocations;
    setBoxCount: React.Dispatch<React.SetStateAction<number>>;
    stageSheet: StageSheet | undefined;
    stages: Stages[];   
    allocateBoxList: AllocateBoxProps[] | undefined;
    setAllocateBoxList: React.Dispatch<React.SetStateAction<AllocateBoxProps[] | undefined>>;
    allocationLoadBoxes: AllocationLoadBoxes[];
    showDelete: boolean;
    isDisabled: boolean;
    weightNotAnIntegerError: number[] | undefined;
    setWeightNotAnIntegerError: React.Dispatch<React.SetStateAction<number[] | undefined>>;
    stageError: number[] | undefined;
    setStageError: React.Dispatch<React.SetStateAction<number[] | undefined>>;
    duplicateError: number[] | undefined;
    setDuplicateError: React.Dispatch<React.SetStateAction<number[] | undefined>>;
    boxError: number[] | undefined;
    setBoxError: React.Dispatch<React.SetStateAction<number[] | undefined>>;
}

const AllocateBoxModalRow = ({
    allocationLoadBoxes,
    index,
    jobId,
    loadId,
    proppantId,
    allocation,
    boxCount,
    setBoxCount,
    allocateBoxList,
    setAllocateBoxList,
    isDisabled,
    weightNotAnIntegerError,
    boxError,
    setBoxError,
    duplicateError,
    setDuplicateError
}: StageSheetPartialModalRowProps): React.ReactElement => {
    const [splitWeight, setSplitWeight] = useState<number| null>();
    const [stage, setStage] = useState('');
    const [allocateBox, setAllocateBox] = useState('');
    const [allocateBoxColor, setAllocateBoxColor] = useState('');
    const [stageColor, setStageColor] = useState('');
    const [isDeleted, setIsDeleted] = useState(false);
    const [isBoxLoaded, setIsBoxLoaded] = useState(false);
    const [boxLoadedConfirmation, setBoxLoadedConfirmation] = useState(false);
    const [weightExceededMaxError, setWeightExceededMaxError] = useState('');
    const [weightNotANumberError, setWeightNotANumberError] = useState('');
    const [weightNotEnteredError, setWeightNotEnteredError] = useState('');
    const [weightOutOfBoundsError, setweightOutOfBoundsError] = useState('');
    const [boxCannotBeDeleted, setBoxCannotBeDeleted] = useState('');
    const [saveButton, setSaveButton] = useState(true);
    const [selectedBox, setSelectedBox] = useState<string | null>();
    const [disableRow, setDisableRow] = useState(false);
    const [currentBoxWeight, setCurrentBoxWeight] = useState(0);
    const [runningBoxWeight, setRunningBoxWeight] = useState(0);
    const [semiAllocated, setSemiAllocated] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const BoxWeight= 50000;

    const allocateBoxes: AllocateBoxProps = {
        id:allocation?.id? allocation?.id : 0,
        index: index,
        jobId: jobId,
        loadId: loadId,
        boxId: allocation?.boxId? allocation?.boxId : 0,
        proppantId: proppantId,
        boxDesc: allocation?.boxDesc? allocation?.boxDesc : '',
        allocationWeight: allocation?.allocationWeight? allocation?.allocationWeight: 0,
        isBoxAllocated: allocation?.isBoxAllocated? allocation?.isBoxAllocated: false,
        isLoadAllocated: allocation?.isLoadAllocated? allocation?.isLoadAllocated: false,
        isSemiAllocated: false,
        isDeleted: false,
        currentWeight: 0,
        isInDanceFloor: allocation?.isInDanceFloor?allocation.isInDanceFloor: false,
    };

    if(allocateBoxList?.length === 0 && index === 0){
        setAllocateBoxList([allocateBoxes]);
        
    }
    
    useEffect(() => {
        if(isDisabled){
            setIsBoxLoaded(false); 
        }
        if(!allocateBoxList){
            const temp = [allocateBoxes];
            setAllocateBoxList(temp);
        }else{
            const tmp = allocateBoxList;
            tmp.push(allocateBoxes);
            setAllocateBoxList(tmp);
        }
        if(allocation){
            setSelectedBox(allocation.boxDesc);
            setSplitWeight(allocation.allocationWeight);
        }
        setRunningBoxWeight(BoxWeight - (allocation && allocation.allocationWeight !== null && !isNaN(allocation.allocationWeight) ? allocation.allocationWeight : 0));
    }, []);

    const errorMessage = {
        boxNullErrorMessage: 'Please select a box',
        weightExceededBoxMaxValue: 'Weight must be between 1000 and ' + BoxWeight ,
        weightNotAnIntegerErrorMessage: 'Enter a valid weight',
        WeightNotEnteredErrorMessage: 'Weight is mandatory to mark the box as Loaded.',
        //WeightOutOfBoundsErrorMessage: 'Maximum allowed weight for the box is '
        duplicateErrorMessage: 'Box must be unique',
        boxCannotBeDeletedMessage: 'Cannot delete Box which is on Dance floor'
    };

    const handleOnChangeWeight = weight => {
        const validWeight = isNaN(weight) ? 0 : weight;
        const validCurrentBoxWeight = isNaN(currentBoxWeight) ? 0 : currentBoxWeight;
        setRunningBoxWeight(BoxWeight - (validWeight + validCurrentBoxWeight));
        
        setWeightNotEnteredError('');
        // if (Number.isNaN(weight) || !Number.isInteger(weight) || weight < 1) weight = -1;
        setSplitWeight(weight);
        
        if(weight>BoxWeight){
            setWeightExceededMaxError(errorMessage.weightExceededBoxMaxValue);
            setSaveButton(false);
        } else{
            setWeightExceededMaxError('');
            setSaveButton(true);
        }
        if(weight === -1){
            setWeightNotANumberError(errorMessage.weightNotAnIntegerErrorMessage);
            setWeightNotANumberError('');
        }
        if(currentBoxWeight + weight > BoxWeight){
            const allowedWeight =  BoxWeight-currentBoxWeight;
            setweightOutOfBoundsError(`Maximum allowed weight for the box is ${allowedWeight}.`);
            setSaveButton(false);
        }
        else{
            setweightOutOfBoundsError('');
            setSaveButton(true);
        }
        allocateBoxList = allocateBoxList?.filter((o, index, arr) =>
            arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index
        );
        const tempAllocateBoxList = allocateBoxList ; 
        tempAllocateBoxList?.map(boxItem => {   
                if (boxItem.index === index && boxItem) {
                    boxItem.allocationWeight = weight;
                }
        });
        setAllocateBoxList(tempAllocateBoxList);

        // if (weightNotAnIntegerError?.includes(index)) {
        //     weightNotAnIntegerError.splice(weightNotAnIntegerError.indexOf(index), 1);
        //     setWeightNotAnIntegerError(weightNotAnIntegerError);
        // }
    };

    const handleOnChangeBox = (boxId, boxDesc, boxColor, currentBoxWeight, semiAllocated) => {
        setSelectedBox(boxDesc);
        setAllocateBox(boxDesc);
        setAllocateBoxColor(boxColor);
        setCurrentBoxWeight(currentBoxWeight);
        setSemiAllocated(semiAllocated);
        setRunningBoxWeight(BoxWeight - (isNaN(currentBoxWeight) ? 0 : currentBoxWeight));
        allocateBoxList = allocateBoxList?.filter((o, index, arr) =>
            arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index
        );
        const tempAllocateBoxList = allocateBoxList ; 
        tempAllocateBoxList?.map(boxItem => { 
                if (boxItem.index === index && boxItem) {
                    boxItem.boxId = boxId;
                    boxItem.boxDesc = boxDesc;
                    boxItem.loadId = loadId;
                    boxItem.proppantId = proppantId;
                    boxItem.isSemiAllocated = semiAllocated;
                    boxItem.currentWeight = currentBoxWeight;
                }
        });
        setAllocateBoxList(tempAllocateBoxList);

        if (duplicateError?.includes(index)) {
            duplicateError.splice(duplicateError.indexOf(index), 1);
            setDuplicateError(duplicateError);
        }
    };

    const handleOnLoaded = () => {
        if(Number.isNaN(splitWeight) || !Number.isInteger(splitWeight) || splitWeight ==0 ||  (splitWeight && splitWeight < 1)){
            setWeightNotEnteredError(errorMessage.WeightNotEnteredErrorMessage);
            setSaveButton(false);
            return;
        }
        setIsBoxLoaded(true);
        setBoxLoadedConfirmation(true);
    };

    const onClickSave = () => {
        allocateBoxList = allocateBoxList?.filter((o, index, arr) =>
            arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index
        );
        const tempBoxList = allocateBoxList;
        tempBoxList?.map(boxItem => { 
            if (boxItem.index === index && boxItem) {
                boxItem.isBoxAllocated = true;
            }
    });
        setAllocateBoxList(tempBoxList);
        setBoxLoadedConfirmation(false);
    };

    const onClickClose = () => {
        setIsBoxLoaded(false);
    };

    const filteredOptions = allocationLoadBoxes.filter((box) =>
        box.boxDesc?.toLowerCase().startsWith(searchTerm.toLowerCase())
      );

    const handleOnDelete = () => {
        allocateBoxList = allocateBoxList?.filter((o, index, arr) =>
            arr.findIndex(item => JSON.stringify(item) === JSON.stringify(o)) === index
        );

        const tempBoxList = allocateBoxList;
        tempBoxList?.map(boxItem => { 
            if (boxItem.index === index && boxItem) {
                if(boxItem.isInDanceFloor){
                    setBoxCannotBeDeleted(errorMessage.boxCannotBeDeletedMessage);
                }else{
                    boxItem.isDeleted = true;
                    setIsDeleted(true);
                    setBoxCount(boxCount - 1);
                }
            }
        });
        setAllocateBoxList(tempBoxList);

        const updatedItems = allocateBoxList?.filter(boxItem => {
            if(!(boxItem.id == 0 && boxItem.isDeleted === true)){
                return boxItem;
            }
        });
        setAllocateBoxList(updatedItems);
    };

    if (isDeleted) {
        return <></>;
    }

    return (
        <><>
            {boxLoadedConfirmation && <Modal show={isBoxLoaded} onHide={onClickClose} dialogClassName="AllocateLoad-Modal-Container">
                {/* {mutationLoading && (
                    <span className="AddStageModal-Loading">
                        <Loading />
                    </span>
                )} */}
                <Modal.Header className="AddStageModal-Header">
                    <Modal.Title className="AddStageModal-Header-Container">
                        <button className="material-icons AddStageModal-X-Button" onClick={onClickClose}>
                            close
                        </button>
                        <div className="AddStageModal-Title">Load Box</div>
                        {/* <div className="AddStageModal-Error">{mutationError}</div> */}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="AllocateLoadModal-Body">
                    <Col md={10}>
                        <div className="AllocateLoadModal-Header">
                        Are you sure you want to mark the box as Loaded?” Loaded boxes will be moved to Unassigned Inventory.
                        </div>
                    </Col>
                </Modal.Body>

                <Modal.Footer className="AddStageModal-Footer">
                    <CustomButton title="Cancel" isBordered onClick={onClickClose} />
                    <CustomButton
                        title="Continue"
                        // isDisabled={(row && column && level) || (!row && !column && !level) ? false : true}
                        onClick={() => onClickSave()} 
                        />
                </Modal.Footer>
            </Modal>}
        </><>
                <tr>
                    <td className="AllocateLoadModal-Column">
                        <Dropdown>
                            <Dropdown.Toggle
                                variant="outline-dark"
                                id="dropdown-basic"
                                className="AllocateLoadModal-Dropdown"
                                disabled={allocation?.isBoxAllocated?allocation.isBoxAllocated:false}
                            >
                                <div className="StageSheetBox" style={{ backgroundColor: `${allocateBoxColor}` }}></div>{' '}
                                <span>{selectedBox ? selectedBox : 'Select Box'}</span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu className='Allocate-Box-Dropdown-Menu'>
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    style={{ margin: "8px 10px", width: "calc(100% - 20px)", borderRadius: "5px" }}
                                />
                                {filteredOptions.map((box, index) => (
                                    <Dropdown.Item
                                        className="StageSheetBox-Item"
                                        key={index}
                                        eventKey={box.boxId? box.boxId:0}
                                        onClick={() => handleOnChangeBox(box.boxId, box.boxDesc, box.proppantColor, box.currentProppantWeight, box.semiAllocated)}
                                    >
                                        <div
                                            className="StageSheetBox"
                                            style={{ backgroundColor: `${box.proppantColor}` }}
                                        ></div>{' '}
                                        &nbsp;{box.boxDesc}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                        <div className="AddStageModal-Error">
                            {semiAllocated && 'Current Weight:' + currentBoxWeight}
                        </div>
                        <div className="AddStageModal-Error">
                            {duplicateError?.includes(index) && errorMessage.duplicateErrorMessage}
                            {boxError?.includes(index) && errorMessage.boxNullErrorMessage + index}
                            {boxCannotBeDeleted && errorMessage.boxCannotBeDeletedMessage}
                        </div>
                
                    </td>

                    <td className="AllocateLoadModal-Column AddStageNumber-Container">
                        <input
                            disabled={allocation?.isBoxAllocated?allocation.isBoxAllocated:false}
                            type="number"
                            className="AddStageNumber"
                            onKeyDown={blockInvalidChar}
                            value={splitWeight? splitWeight:''}
                            onChange={element => handleOnChangeWeight(parseInt(element.target.value))} />
                        <div className="AllocateLoadModal-Error">
                            {weightNotAnIntegerError?.includes(index) && errorMessage.weightExceededBoxMaxValue}
                            {weightNotANumberError && errorMessage.weightNotAnIntegerErrorMessage}
                            {weightNotEnteredError && errorMessage.WeightNotEnteredErrorMessage}
                            {weightOutOfBoundsError}
                        </div>
                        <div className="AddStageModal-Error">
                            {!allocation?.isBoxAllocated && runningBoxWeight >= 0 && 'Remaining capacity :' + runningBoxWeight}
                        </div>
                    </td>

                    <td className="AllocateLoadModal-Column-Button">
                        <CustomButton 
                            isDisabled={allocation?.isBoxAllocated?allocation.isBoxAllocated:false} 
                            additionalStyle={isBoxLoaded || allocation?.isBoxAllocated ? 'AllocateLoad-Button-Loaded-Focus': 'AllocateLoad-Button-Loaded'} 
                            title="Loaded" 
                            isBordered 
                            onClick={handleOnLoaded} 
                        />
                        <CustomButton 
                        isDisabled={allocation?.weightRemaining != null && allocation?.weightRemaining == 0}
                        additionalStyle={(allocation?.weightRemaining != null && allocation?.weightRemaining == 0)?
                        'AllocateLoad-Button Inventory-Button-Disabled':'AllocateLoad-Button'} 
                        title="Delete"  
                        isBordered 
                        onClick={handleOnDelete} />
                    </td>
                </tr>
            </></>
    );
};

export default AllocateBoxModalRow;
